"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getActualBusinessStartIsoDate = void 0;
/**
 * @returns earliest incorporation date in ISO format or null. When it derives the date from only the year
 * it will assume Jan 1st of the available year.
 */
const getActualBusinessStartIsoDate = (businessStartValues, options = {}) => {
    const { incorporationDate, incorporationYear, originalBusinessStartYear, priorBusinessIncorporationDate } = options;
    // below if a value exists both in the company and in the options object we take the value from the options object
    const currentIncorporation = incorporationDate || businessStartValues.incorporationDate;
    const currentIncorporationDateNum = currentIncorporation ? new Date(currentIncorporation).getTime() : null;
    const currentIncorporationYear = incorporationYear || businessStartValues.incorporationYear;
    const currentIncorporationYearDateNum = currentIncorporationYear
        ? new Date(`${currentIncorporationYear}-01-01T00:00:00.000Z`).getTime()
        : null;
    const currentPriorBusinessIncorporationDate = priorBusinessIncorporationDate || businessStartValues.priorBusinessIncorporationDate;
    const currentPriorBusinessIncorporationDateYearNum = currentPriorBusinessIncorporationDate
        ? new Date(currentPriorBusinessIncorporationDate).getTime()
        : null;
    const currentOriginalBusinessStartYear = originalBusinessStartYear || businessStartValues.originalBusinessStartYear;
    const currentOriginalBusinessStartYearDateNum = currentOriginalBusinessStartYear
        ? new Date(`${currentOriginalBusinessStartYear}-01-01T00:00:00.000Z`).getTime()
        : null;
    // For either current incorporation or prior incorporation, we use date over year
    // We then take the minimum between current and prior incorporation
    const currentIncorporationDate = currentIncorporationDateNum || currentIncorporationYearDateNum;
    const currentPriorDate = currentPriorBusinessIncorporationDateYearNum || currentOriginalBusinessStartYearDateNum;
    let earliestIncorporationDate = currentPriorDate || currentIncorporationDate;
    if (!earliestIncorporationDate) {
        return null;
    }
    if (currentIncorporationDate && currentIncorporationDate < earliestIncorporationDate) {
        earliestIncorporationDate = currentIncorporationDate;
    }
    return new Date(earliestIncorporationDate).toISOString();
};
exports.getActualBusinessStartIsoDate = getActualBusinessStartIsoDate;
